import React from 'react';
import { Box } from '@mui/material';

interface PageTransitionProps {
  children: React.ReactNode;
}

const PageTransition: React.FC<PageTransitionProps> = ({ children }) => {
  return (
    <Box
      sx={{
        width: '100%',
        animation: 'smoothEntrance 0.6s cubic-bezier(0.4, 0, 0.2, 1)',
        '@keyframes smoothEntrance': {
          '0%': {
            opacity: 0,
            transform: 'translateX(10px)', // Subtle slide from right
          },
          '100%': {
            opacity: 1,
            transform: 'translateX(0)',
          },
        },
      }}
    >
      {children}
    </Box>
  );
};

export default PageTransition;